import { ajaxSetup, ajax, getJSON } from 'jquery';

import { IOptions } from '../types/options';
import { ICreateForm } from '../actions/types';

import { getConfig, notify } from '../components/Utils';
import {
  deleteFileExpertData,
  saveTextAnswerExpertData,
  sendExpertData,
  uploadFileExpertData,
} from '../actions';
import axios from 'axios';

export interface IHandler {
  (...params: any[]): void;
}

export interface IErrorHandler {
  (jqxhr: any, textStatus: string, error?: any): void;
  // (status: number, error: string): void;
}

export interface IProgressHandler {
  (progress: number): void;
}

export interface IHandlers {
  before?: IHandler;
  success?: IHandler;
  anyway?: IHandler;
  error?: IErrorHandler;
  progress?: IProgressHandler;
}

export interface IFileOptions {
  id: string;
  maxSize: number;
  format: string;
  element: HTMLInputElement;
}

interface RequestOptions {
  url: string;
  method: string;
  contentType?: string | boolean;
  xhr?: () => XMLHttpRequest;
  processData?: boolean;
  data?: any;
}

export function createApiClient(form_type: string = null, process_id = 0) {
  const formates = {
    PDF: ['PDF'],
    Image: ['JPG', 'PNG', 'JPEG'],
  };

  ajaxSetup({
    xhrFields: {
      withCredentials: true,
    },
  });

  const config = getConfig();
  if (form_type !== null) {
    config.form_type = form_type;
  }
  if (process_id !== null) {
    config.process_id = process_id;
  }
  // config.filesUrl = `${config.filesUrl}/${config.id}/${config.valuesId}`;

  // return new ApiClient(config, formates, false)

  return new ApiClient(config, formates, false);
}

export const checkDefaultErrors = (status, _statusText) => {
  switch (status) {
    case 401: {
      if (window.top !== window.self) {
        // @ts-ignore
        window.top.location.href = '/#/not-authorized';
      } else {
        window.location.href = '/#/not-authorized';
      }

      break;
    }
    default:
      break;
  }
};

const errorHandler = (_, response) => {
  const { errors } = JSON.parse(response);
  console.log('errors:', errors, ' response:', response);
  if (typeof errors !== 'undefined' && errors.length > 0) {
    if (errors[0].error.code === '400') {
      notify(errors[0].error.message);
      window.location.reload();
    }
  }
};

export class ApiClient {
  private lock: boolean;
  private options: IOptions;
  private setValueUrl: string;
  private urlApi: string;
  private userApi: string;
  private companiesApi: string;
  private actionUrl: string;
  private filesUrl: string;

  public readonly FileFormats: {
    [format: string]: Array<string>;
  };

  constructor(
    options: IOptions,
    formats: {
      [format: string]: Array<string>;
    },
    lock: boolean,
  ) {
    this.options = options;
    this.setValueUrl =
      this.options.apiUrl +
      '/item/' +
      this.options.form_type +
      '/' +
      this.options.process_id +
      '/';
    this.actionUrl =
      this.options.apiUrl + '/action/' + this.options.process_id + '/';
    this.urlApi = this.options.apiUrl;
    this.userApi = this.options.apiUser;
    this.companiesApi = this.options.companyUrl;
    this.filesUrl =
      this.options.filesUrl +
      '/' +
      this.options.form_type +
      '/' +
      this.options.process_id +
      '/';

    this.FileFormats = formats;

    this.lock = lock;
  }

  public isLocked() {
    return this.lock;
  }

  public getReportUrl(formId: string, valuesId: string) {
    return `${this.userApi}/report/${formId}/${valuesId}/`;
  }

  public getAttachFileUrl(formId: string, valuesId: number, uid: string) {
    return `${this.options.apiUrl}/${formId}/${valuesId}/notify/${uid}/files/`;
  }

  public createSession(formId: string, company: object, handlers: IHandlers) {
    this.send(
      {
        url: `${this.urlApi}/${formId}/`,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(company),
      },
      handlers,
    );
  }

  public me(handlers: IHandlers) {
    getJSON(`${this.userApi}/me/`, handlers.success).fail(handlers.error);
  }

  public getNotify(formId: string, values: number, handlers: IHandlers) {
    getJSON(`${this.urlApi}/notify/${formId}/${values}/`, handlers.success);
  }

  public getVotesResult(formId: string, handlers: IHandlers) {
    getJSON(`${this.urlApi}/item/${formId}/votes/`, handlers.success);
  }

  public getHistory(request: number, handlers: IHandlers) {
    getJSON(
      `${this.urlApi}/item/${request}/status_history/`,
      handlers.success,
    ).fail(handlers.error);
  }

  public company(handlers: IHandlers) {
    getJSON(`${this.userApi}/company/`, handlers.success);
  }

  public getCompanyORN(inn: string, handlers: IHandlers) {
    getJSON(`${this.userApi}/company/orn/${inn}/`, handlers.success).fail(
      handlers.error,
    );
  }

  public getTags(handlers: IHandlers) {
    getJSON(`${this.companiesApi}/tags/`, handlers.success).fail(
      handlers.error,
    );
  }

  public getCities(handlers: IHandlers) {
    getJSON(`${this.companiesApi}/cities/`, handlers.success).fail(
      handlers.error,
    );
  }

  public redirect(url: string) {
    window.location.href = `${this.userApi}/auth?url=${encodeURIComponent(
      window.location.href,
    )}/`;
  }

  public singout(url: string) {
    window.location.href = `${this.userApi}/singout?url=${encodeURIComponent(
      window.location.href,
    )}/`;
  }

  public sendValues(handlers: IHandlers) {
    this.send(
      {
        url: this.actionUrl + '/send/',
        method: 'POST',
      },
      handlers,
    );
  }

  public sendDocument(
    handlers: IHandlers,
    form?: any,
    sendType?: string | undefined,
    trailingSlash?: boolean,
  ) {
    const _sendType = sendType ? `/${sendType}` : '';

    this.send(
      {
        url: this.setValueUrl + 'send' + _sendType + (trailingSlash ? '/' : ''),
        method: 'POST',
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify(form || {}),
      },
      handlers,
    );
  }

  public sendRevoke(handlers: IHandlers, form?: any) {
    this.send(
      {
        url: this.setValueUrl + 'revoke/',
        method: 'POST',
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify(form || {}),
      },
      handlers,
    );
  }

  public sendAdditional(handlers: IHandlers) {
    this.send(
      {
        url: this.actionUrl + '/additional/',
        method: 'POST',
      },
      handlers,
    );
  }

  public sendPDF(handlers: IHandlers) {
    this.send(
      {
        url: this.actionUrl + '/pdf/',
        method: 'POST',
      },
      handlers,
    );
  }

  public cloneRequest(handlers: IHandlers) {
    this.send(
      {
        url: `${this.actionUrl}/clone/`,
        method: 'POST',
      },
      handlers,
    );
  }

  public deleteValues(handlers: IHandlers) {
    this.send(
      {
        url: this.actionUrl + '/delete/',
        method: 'DELETE',
      },
      handlers,
    );
  }

  public getFileUrl(
    controlId: string,
    fileName: string,
    timestamp?: number,
  ): string {
    if (timestamp !== undefined) fileName = timestamp + '/' + fileName;

    return encodeURI(
      `${this.options.filesUrl}/${this.options.form_type}/${this.options.process_id}/${controlId}/${fileName}/`,
    );
  }

  public setValue(id: string, value: any, handlers: IHandlers = null) {
    handlers.error = errorHandler;

    this.send(
      {
        url: this.setValueUrl + id + '/',
        method: 'POST',
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify({
          timestamp: Date.now(),
          value: value,
        }),
      },
      handlers,
    );
  }

  public setValueSync(id: string, value: any, handlers: IHandlers = null) {
    this.send(
      {
        url: this.setValueUrl + '/' + id + '/',
        method: 'POST',
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify({
          timestamp: Date.now(),
          value,
        }),
      },
      handlers,
      false,
    );
  }

  public putValue(id: string, value: any, handlers: IHandlers = null): number {
    const timestamp = Date.now();

    this.send(
      {
        url: this.setValueUrl + '/' + id + '/',
        method: 'PUT',
        contentType: 'application/json',
        data: JSON.stringify({
          timestamp: timestamp,
          value: value,
        }),
      },
      handlers,
    );
    return timestamp;
  }

  public removeValue(
    id: string,
    timestamp: number,
    handlers: IHandlers = null,
  ) {
    handlers.error = errorHandler;
    this.send(
      {
        url: this.setValueUrl + id + '/' /* + "/?timestamp=" + timestamp, */,
        method: 'DELETE',
      },
      handlers,
    );
  }

  public removeReportPdf(
    formId: string,
    values: string,
    handlers: IHandlers = null,
  ) {
    this.send(
      {
        url: `${this.options.apiUrl}/${formId}/${values}/report/`,
        method: 'DELETE',
      },
      handlers,
    );
  }

  public setFileValue(
    options: IFileOptions,
    value: any,
    fileId: string,
    handlers: IHandlers,
  ): string {
    const file = options.element.files[0];
    if (file == undefined || file == null) return null;

    const data = new FormData();
    data.append('file', file);
    data.append('value', value);
    data.append('fileId', fileId);

    let success: IHandler = null;
    if (handlers != null && handlers.success != null) {
      success = handlers.success;
      handlers.success = function (res) {
        success(res);
      };
      handlers.error = errorHandler;
    }

    this.send(
      {
        xhr: function (): XMLHttpRequest {
          const xhr = new XMLHttpRequest();
          if (handlers != null && handlers.progress != null) {
            xhr.upload.addEventListener('progress', (e) => {
              handlers.progress((e.loaded / e.total) * 100);
            });
          }
          return xhr;
        },
        url: this.filesUrl + options.id + '/file/',
        method: 'POST',
        contentType: false,
        data: data,
        processData: false,
      },
      handlers,
    );
  }

  public deleteFileValue(
    id: string,
    fileName: string,
    value: any,
    fileId: string,
    handlers: IHandlers,
  ) {
    handlers.error = errorHandler;
    this.send(
      {
        url: encodeURI(this.filesUrl + id + '/' + fileId + '/'),
        method: 'DELETE',
      },
      handlers,
    );
  }

  public getFormByUid(id: string, values: number, handlers: IHandlers) {
    getJSON(`${this.urlApi}/${id}/${values}/`, handlers.success).fail(
      handlers.error,
    );
  }

  public getAllValues(handlers: IHandlers) {
    getJSON(this.urlApi + '/', handlers.success).fail(handlers.error);
  }

  public getForms(page: number, pagesize: number, handlers: IHandlers) {
    if (!page || !pagesize) {
      getJSON(`${this.urlApi}/1/20/true/desc/`, handlers.success)
        .fail(handlers.error)
        .always(handlers.anyway);
    } else {
      getJSON(`${this.urlApi}/${page}/${pagesize}/true/desc/`, handlers.success)
        .fail(handlers.error)
        .always(handlers.anyway);
    }
  }

  // public getSettings(handlers: IHandlers) {
  //     getJSON(`${this.urlApi}/settings`, handlers.success).always(handlers.anyway);
  // }

  // public openForm(valuesId: string, formId: string, handlers: IHandlers) {
  //     getJSON(`${this.urlApi}/values/${valuesId}/${formId}`, handlers.success)
  //         .fail(handlers.error);
  // }
  //

  public createForm(data: ICreateForm, handlers: IHandlers) {
    this.send(
      {
        url: `${this.urlApi}/item/create/`,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(data),
      },
      handlers,
    );
  }

  public onUploadProtocols(
    { protocol, enFieldsAvailable, forceWithoutDocs },
    handlers,
  ) {
    axios
      .post(
        `${this.urlApi}/item/create/from_protocol${
          forceWithoutDocs ? '?force=true' : ''
        }`,
        {
          protocol,
          enFieldsAvailable,
        },
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      )
      .then(handlers.success)
      .catch(handlers.error);
  }

  public copyForm(form_type: string, process_id: number, handlers: IHandlers) {
    this.send(
      {
        url: `${this.urlApi}/item/clone/${form_type}/${process_id}/`,
        method: 'POST',
      },
      handlers,
    );
  }

  public revokeForm(
    form_type: string,
    process_id: number,
    message: string,
    handlers: IHandlers,
  ) {
    this.send(
      {
        url: `${this.urlApi}/item/${form_type}/${process_id}/revoke/`,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ message }),
      },
      handlers,
    );
  }

  public getPlagsearch(
    formType: string,
    processId: string | number,
    handlers: IHandlers,
  ) {
    getJSON(
      `${this.urlApi}/item/${formType}/${processId}/plagsearch`,
      handlers.success,
    ).fail(handlers?.error);
  }

  public getRecommendations(
    formType: string,
    processId: string | number,
    handlers: IHandlers,
  ) {
    this.send(
      {
        url: `${this.urlApi}/advice_common/${formType}/${processId}/`,
        method: 'POST',
      },
      handlers,
    );
  }

  public deleteForm(
    form_type: string,
    process_id: number,
    handlers: IHandlers,
  ) {
    this.send(
      {
        url: `${this.urlApi}/item/${form_type}/${process_id}/`,
        method: 'DELETE',
      },
      handlers,
    );
  }

  public openForm(form_type: string, process_id: number, handlers: IHandlers) {
    getJSON(`${this.urlApi}/item/${form_type}/${process_id}/`, handlers.success)
      .fail(handlers.error)
      .always(handlers.anyway);
  }

  public companyInfo(inn: string, handlers: IHandlers) {
    getJSON(`${this.userApi}/company/${inn}/`, handlers.success).fail(
      handlers.error,
    );
  }

  public getExpertData(
    form_type: string,
    process_id: number,
    handlers: IHandlers,
  ) {
    getJSON(
      `${this.options.baseUrl}/expert_question/questions/${form_type}/${process_id}/`,
      handlers.success,
    )
      .fail(handlers.error)
      .always(handlers.anyway);
  }

  public getDocumentsData(
    form_type: string,
    process_id: number,
    handlers: IHandlers,
  ) {
    getJSON(
      `${this.options.baseUrl}/documents/${form_type}/${process_id}/`,
      handlers.success,
    )
      .fail(handlers.error)
      .always(handlers.anyway);
  }

  public getStatusHistory(document_id: string, handlers: IHandlers) {
    getJSON(
      `${this.options.baseUrl}/documents/status_history/${document_id}`,
      handlers.success,
    )
      .fail(handlers.error)
      .always(handlers.anyway);
  }

  public uploadDocumentsFile(
    signature_type: string,
    document_id: string,
    form_data,
    handlers,
  ) {
    axios
      .post(
        `${this.options.baseUrl}/documents/sign/${signature_type}/${document_id}`,
        form_data,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      )
      .then(handlers.success)
      .catch(handlers.error);
  }

  public sendFileToGK(document_id: string, snils: string, handlers) {
    axios
      .post(`${this.options.baseUrl}/documents/sign/gk/${document_id}`, {
        snils,
      })
      .then(handlers.success)
      .catch(handlers.error);
  }

  public saveTextAnswerExpertData(form_type, question_id, text, handlers) {
    this.send(
      {
        url: `${this.options.baseUrl}/expert_question/answer_text/${form_type}/${question_id}/`,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
          value: text,
        }),
      },
      handlers,
    );
  }

  public sendExpertData(form_type, question_id, handlers) {
    this.send(
      {
        url: `${this.options.baseUrl}/expert_question/question/${form_type}/${question_id}/send`,
        method: 'POST',
      },
      handlers,
    );
  }

  public uploadFileExpertData(form_data, form_type, question_id, handlers) {
    axios
      .post(
        `${this.options.baseUrl}/expert_question/answer_file/${form_type}/${question_id}/`,
        form_data,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      )
      .then(handlers.success)
      .catch(handlers.error);
  }

  public uploadFileOption(apiUrl, form_data, handlers) {
    axios
      .post(apiUrl, form_data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(handlers.success)
      .catch(handlers.error);
  }

  public deleteFileExpertData(form_type, question_id, file_uuid, handlers) {
    this.send(
      {
        url: `${this.options.baseUrl}/expert_question/answer_file/${form_type}/${question_id}/${file_uuid}`,
        method: 'DELETE',
      },
      handlers,
    );
  }

  public suggest(text: string, handlers: IHandlers) {
    this.send(
      {
        url: `${this.userApi}/suggest/`,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
          query: text,
        }),
      },
      handlers,
    );
  }

  public getCompanies(handlers: IHandlers) {
    getJSON(`${this.companiesApi}/data/`, handlers.success)
      .fail(handlers.error)
      .always(handlers.anyway);
  }

  public getValue(controlId: string, handlers: IHandlers) {
    this.send(
      {
        url: this.setValueUrl + '/' + controlId + '/',
        method: 'GET',
      },
      handlers,
    );
  }

  public isRemovePanelBlock(key: string, handlers: IHandlers) {
    this.send(
      {
        url: `${this.setValueUrl}/${key}/isremove/`,
        method: 'GET',
      },
      handlers,
    );
  }

  public hasRemoveBlock(key: string, handlers: IHandlers) {
    this.send(
      {
        url: `${this.setValueUrl}/${key}/hasremove/`,
        method: 'GET',
      },
      handlers,
    );
  }

  private send(options: RequestOptions, handlers: IHandlers, async = true) {
    let success: IHandler = null;
    let error: IErrorHandler = null;
    if (handlers) {
      success = handlers.success;
      error = handlers.error;
    }

    ajax({
      xhr: options.xhr,
      url: options.url,
      type: options.method,
      contentType: options.contentType as string | false,
      data: options.data,
      processData: options.processData,
      success: success,
      async,
      error: function (jqXHR: JQueryXHR) {
        checkDefaultErrors(jqXHR.status, jqXHR.responseText);
        if (error != null) error(jqXHR.status, jqXHR.responseText);
      } as (jqXHR: any) => void,
    });
  }

  private static getFileExtension(fileName: string) {
    return fileName.substring(fileName.lastIndexOf('.') + 1).toUpperCase();
  }

  public validateOkpd(id: string, handlers: IHandlers) {
    getJSON(
      `/candidate-request/public/v1/forms/get_by_code/cls_okpd2/${id}`,
      handlers.success,
    ).fail(handlers.error);
  }

  public validateTnved(id: string, handlers: IHandlers) {
    getJSON(
      `/candidate-request/public/v1/forms/get_by_code/sk_tn_ved/${id}`,
      handlers.success,
    ).fail(handlers.error);
  }

  public getCompanySuggestions(value: string, handlers: IHandlers) {
    getJSON(
      `/candidate-request/public/v1/company/suggest_company/${value}`,
      handlers.success,
    ).fail(handlers.error);
  }

  public checkIsCompanyRelatesToSkolkovo(value: string, handlers: IHandlers) {
    getJSON(
      `/candidate-request/public/v1/forms/get_mtk_status/?ogrn=${value}`,
      handlers.success,
    ).fail(handlers.error);
  }

  public getResidentProjectsInfo(value: string, handlers: IHandlers) {
    getJSON(
      `/candidate-request/public/v1/forms/get_mtk_projects/?ogrn=${value}`,
      handlers.success,
    ).fail(handlers.error);
  }

  public sendMtkRequest(form: any, handlers: IHandlers) {
    this.send(
      {
        url: 'public/v1/forms/item/create/from_mtk',
        method: 'POST',
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify(form),
      },
      handlers,
    );
  }
}
